import { PrimaryButton, SecondaryButton, TextLinkButton } from '../../button';
import { styleVariables } from '../../../style';
import styled from 'styled-components';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useEffect, useRef } from 'react';
import { CommentPreviewContent, CommentPreviewSurface, CommentTextArea } from './comment-preview-surface.component';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledPopup = styled(CommentPreviewSurface).withConfig({
  displayName: "comment-popupcomponent__StyledPopup",
  componentId: "sc-cnto2r-0"
})(["width:360px;max-width:calc(100vw - 24px);z-index:1000;padding:16px 18px;"]);
var StyledSelectedText = styled.div.withConfig({
  displayName: "comment-popupcomponent__StyledSelectedText",
  componentId: "sc-cnto2r-1"
})(["overflow:hidden;margin-bottom:10px;color:", ";font-family:Georgia,serif;font-size:13px;font-style:italic;line-height:20px;text-overflow:ellipsis;white-space:nowrap;"], function (props) {
  return props.theme.color.fontColorSecondary;
});
var StyledCommentContent = styled(CommentPreviewContent).withConfig({
  displayName: "comment-popupcomponent__StyledCommentContent",
  componentId: "sc-cnto2r-2"
})([""]);
var StyledActions = styled.div.withConfig({
  displayName: "comment-popupcomponent__StyledActions",
  componentId: "sc-cnto2r-3"
})(["display:flex;justify-content:flex-end;gap:12px;margin-top:14px;"]);
var StyledActionButton = styled(TextLinkButton).withConfig({
  displayName: "comment-popupcomponent__StyledActionButton",
  componentId: "sc-cnto2r-4"
})(["padding:0;color:", ";font-size:14px;font-weight:600;&.delete-action{color:", ";}"], function (props) {
  return props.theme.color.fontColorDefault;
}, function (props) {
  return props.theme.color.error;
});
var StyledEditFooter = styled.div.withConfig({
  displayName: "comment-popupcomponent__StyledEditFooter",
  componentId: "sc-cnto2r-5"
})(["display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:12px;"]);
var StyledCharacterCount = styled.span.withConfig({
  displayName: "comment-popupcomponent__StyledCharacterCount",
  componentId: "sc-cnto2r-6"
})(["color:", ";font-size:12px;white-space:nowrap;"], function (props) {
  return props.theme.color.fontColorSecondary;
});
export var CommentPopup = function CommentPopup(_ref) {
  var position = _ref.position,
      commentId = _ref.commentId,
      content = _ref.content,
      isEditing = _ref.isEditing,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      onClose = _ref.onClose,
      onUpdateContent = _ref.onUpdateContent,
      labels = _ref.labels,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$selectedText = _ref.selectedText,
      selectedText = _ref$selectedText === void 0 ? '' : _ref$selectedText,
      _ref$highlightColor = _ref.highlightColor,
      highlightColor = _ref$highlightColor === void 0 ? styleVariables.highlightColors.color1 : _ref$highlightColor;
  var popupRef = useRef(null);
  useEffect(function () {
    if (!position) return;

    var handleOutsideClick = function handleOutsideClick(event) {
      var _popupRef$current;

      var target = event.target;
      if (!(target instanceof Node) || (_popupRef$current = popupRef.current) !== null && _popupRef$current !== void 0 && _popupRef$current.contains(target)) return;
      var highlightedComment = target instanceof Element ? target.closest('[data-comment-id]') : null;
      if ((highlightedComment === null || highlightedComment === void 0 ? void 0 : highlightedComment.getAttribute('data-comment-id')) === commentId) return;
      onClose();
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      return document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [commentId, onClose, position]);
  if (!position) return null;
  return /*#__PURE__*/_jsxs(StyledPopup, {
    ref: popupRef,
    className: "popup-comment",
    $commentColor: highlightColor,
    $borderMode: "accent",
    style: {
      position: 'fixed',
      top: position.top,
      left: position.left
    },
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    children: [/*#__PURE__*/_jsxs(StyledSelectedText, {
      className: "popup-comment",
      children: ["\u201C", selectedText]
    }), isEditing ? /*#__PURE__*/_jsxs("div", {
      className: "popup-comment",
      children: [/*#__PURE__*/_jsx(CommentTextArea, {
        rows: 4,
        maxLength: 750,
        placeholder: labels.enterComment || labels.comment,
        onChange: function onChange(e) {
          return onUpdateContent(e.target.value);
        },
        value: content,
        disabled: loading,
        className: "popup-comment",
        onKeyDown: function onKeyDown(event) {
          if ((event.metaKey || event.ctrlKey) && event.key === 'Enter' && content.trim()) {
            event.preventDefault();
            onSave(commentId, content);
          }
        }
      }), /*#__PURE__*/_jsxs(StyledEditFooter, {
        className: "popup-comment",
        children: [/*#__PURE__*/_jsxs(StyledCharacterCount, {
          className: "popup-comment",
          children: [content.length, "/750 \xB7 ", labels.shortcutToSave || '⌘↵ to save']
        }), /*#__PURE__*/_jsxs(StyledActions, {
          className: "popup-comment",
          children: [/*#__PURE__*/_jsx(SecondaryButton, {
            className: "popup-comment",
            onClick: onCancel,
            disabled: loading,
            size: "middle",
            children: labels.cancel
          }), /*#__PURE__*/_jsx(PrimaryButton, {
            className: "popup-comment",
            loading: loading,
            onClick: function onClick() {
              return onSave(commentId, content);
            },
            disabled: !content.trim(),
            size: "middle",
            children: labels.save
          })]
        })]
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledCommentContent, {
        className: "popup-comment",
        children: content
      }), /*#__PURE__*/_jsxs(StyledActions, {
        className: "popup-comment",
        children: [/*#__PURE__*/_jsx(StyledActionButton, {
          icon: /*#__PURE__*/_jsx(EditOutlined, {
            className: "popup-comment"
          }),
          onClick: onEdit,
          disabled: loading,
          className: "popup-comment",
          children: labels.edit || 'Edit'
        }), /*#__PURE__*/_jsx(StyledActionButton, {
          icon: /*#__PURE__*/_jsx(DeleteOutlined, {
            className: "popup-comment"
          }),
          onClick: function onClick() {
            return onDelete(commentId);
          },
          disabled: loading,
          className: "popup-comment delete-action",
          children: labels["delete"] || 'Delete'
        })]
      })]
    })]
  });
};